import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Icon } from '@storable/canaveral-components';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  feedback: PropTypes.string.isRequired,
};

const defaultProps = {
  className: undefined,
};

const FileFeedback = ({
  className,
  feedback,
}) => (
  <span className={cx(styles.feedback, className)}>
    <Icon context="positive" id="success" />
    <span>{feedback}</span>
  </span>
);

FileFeedback.propTypes = propTypes;
FileFeedback.defaultProps = defaultProps;

export default FileFeedback;
